import { render, staticRenderFns } from "./AttachmentsView.vue?vue&type=template&id=90d1d8ca&"
import script from "./AttachmentsView.vue?vue&type=script&lang=js&"
export * from "./AttachmentsView.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports